import React from 'react';
import CreativeCardsContainer from '../../Componant/Bonus-Ui/Cards/CreativeCards';

const CreativeCards = () => {
  return (
    <div className='page-body'>
      <CreativeCardsContainer />
    </div>
  );
};

export default CreativeCards;
